// @ts-nocheck
import { cartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { quantityInputStyles } from "@store/Themes/common/mixins/form";
import { css } from "styled-components";

Object.assign(cartLineQuantityStyles, {
    editableQuantityTextField: {
        labelProps: {
            css: css`
                display: none;
            `,
        },
        cssOverrides: {
            inputSelect: css`
                ${quantityInputStyles()}
            `,
        },
    },
    readOnlyQuantityText: {
        extendedStyles: {
            heading: {
                css: css`
                    display: none;
                `,
            },
        },
    },
});
